import {Routes} from '@angular/router';
import {DASHBOARD_ROUTES} from '@pages/dashboard/dashboard.routes';
import {USERS_ROUTES} from '@pages/users/users.routes';
import {FILEMANAGER_ROUTES} from '@pages/filemanager/filemanager.routes';

export const FULL_LAYOUT_ROUTES: Routes = [
  {path: '', children: DASHBOARD_ROUTES},
  {path: 'users', children: USERS_ROUTES},
  {path: 'filemanager', children: FILEMANAGER_ROUTES,}
];
